import AuditoriaIndexPage from "@/Pages/Auditoria/index.vue";
import AuditoriaAulas from "@/Pages/Auditoria/AuditoriaAulas.vue";
import AuditoriaAlunos from "@/Pages/Auditoria/AuditoriaAlunos.vue";
import AuditoriaPlanosBimestrais from "@/Pages/Auditoria/AuditoriaPlanosBimestrais.vue";
import AuditoriaPlanosBimestraisInfantis from "@/Pages/Auditoria/AuditoriaPlanosBimestraisInfantis.vue";
import AuditoriaGestoesDeAulas from "@/Pages/Auditoria/AuditoriaGestoesDeAulas.vue";
import AuditoriaTurmas from "@/Pages/Auditoria/AuditoriaTurmas.vue";
import AuditoriaMatriculas from "@/Pages/Auditoria/AuditoriaMatriculas.vue";
import { can } from "@/plugins/can";

const checkPermission = (permissions) => {
  return (to, from, next) => {
    if (!can(permissions)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
};

export default [
  {
    path: "/auditoria/",
    name: "auditoria",
    component: AuditoriaIndexPage,
    beforeEnter: checkPermission(["auditoria.*"]),
  },
  {
    path: "/auditoria/aulas",
    name: "auditoria.aulas",
    component: AuditoriaAulas,
    beforeEnter: checkPermission(["auditoria.*"]),
  },
  {
    path: "/auditoria/alunos",
    name: "auditoria.alunos",
    component: AuditoriaAlunos,
    beforeEnter: checkPermission(["auditoria.*"]),
  },
  {
    path: "/auditoria/planos-bimestrais",
    name: "auditoria.planos-bimestrais",
    component: AuditoriaPlanosBimestrais,
    beforeEnter: checkPermission(["auditoria.*"]),
  },
  {
    path: "/auditoria/planos-bimestrais-infantis",
    name: "auditoria.planos-bimestrais-infantis",
    component: AuditoriaPlanosBimestraisInfantis,
    beforeEnter: checkPermission(["auditoria.*"]),
  },
  {
    path: "/auditoria/gestoes-de-aulas",
    name: "auditoria.gestoes-de-aulas",
    component: AuditoriaGestoesDeAulas,
    beforeEnter: checkPermission(["auditoria.*"]),
  },
  {
    path: "/auditoria/turmas",
    name: "auditoria.turmas",
    component: AuditoriaTurmas,
    beforeEnter: checkPermission(["auditoria.*"]),
  },
  {
    path: "/auditoria/matriculas",
    name: "auditoria.matriculas",
    component: AuditoriaMatriculas,
    beforeEnter: checkPermission(["auditoria.*"]),
  },
];
